import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons"
import AgTechLeftPaneTabPage from "@agtech/web/components/Pages/Tabbed/Flavors/AgTechLeftPaneTabPage"
import LotCategorySettingsPage from "../../lotCategories/pages/LotCategorySettingsPage"
import AgTechViewDialog from "@agtech/web/components/Portals/Dialogs/AgTechViewDialog"
import SaleDiscountViewGrid from "../../discounts/components/grids/SaleDiscountViewGrid"
import LogoUpdateForm from "@agtech/web/integrations/operation/logo/forms/OperationLogoUpdateForm"
import DocumentHeaderConfigurationPage from "../pages/DocumentHeaderConfigurationPage"
import InvoiceDocumentConfigurationPage from "../pages/InvoiceDocumentConfigurationPage"

const SaleSettingsViewDialog = () => {
    return (
        <AgTechViewDialog
            structure={{
                header: () => ({
                    header: 'My Sale Settings',
                    detail: 'Use the options below to configure common settings across your sales'
                }),
                width: '1100px',
            }}
        >
            {() => (
                <AgTechLeftPaneTabPage
                    tabGroups={[
                        {
                            header: 'Sales',
                            tabs: [
                                { text: 'Lot Categories', content: () => <LotCategorySettingsPage />},
                                { text: 'Sale Discounts', content: () => <SaleDiscountViewGrid />}
                            ]
                        },
                        {
                            header: 'Documents',
                            tabs: [
                                { text: 'Document Headers', content: () => <DocumentHeaderConfigurationPage />},
                                { text: 'Invoice Fields', content: () => <InvoiceDocumentConfigurationPage />},
                            ]
                        },
                        {
                            header: 'Operation',
                            tabs: [
                                { text: 'Logo', content: () => <LogoUpdateForm />}
                            ]
                        },
                    ]}
                />
            )}
        </AgTechViewDialog>
    )
}

SaleSettingsViewDialog.ButtonProps = {
    text: 'Update Sale Settings',
    icon: 'fas fa-cog',
    action: (e: AgTechClickEventHandler) => e.dialogs.openDialog({
        dialog: () => <SaleSettingsViewDialog />
    })
}

SaleSettingsViewDialog.Button = (props: AgTechButtonProps) => (
    <AgTechButton
        {...SaleSettingsViewDialog.ButtonProps}
        {...props}
    />
)

export default SaleSettingsViewDialog